import { FC, ReactElement, useEffect, useId } from 'react';

import { Loader } from '@pp/core/src/components/loader/index';
import { useGameStateSlice } from '@pp/core/src/store/slices/game/selectors';
import { GameStatus } from '@pp/core/src/store/slices/game/types';

import { useTableTopDataFetcher } from '../../../../store/apiHooks/useTableTopDataFetcher';
import { useGameDispatch } from '../../../../store/GameStore';
import { useHighflyerGameStateSlice } from '../../../../store/slices/highflyerGame/selectors';
import { highflyerGameStateActions } from '../../../../store/slices/highflyerGame/slice';
import { ScrollableWrapper } from '../../../tableSheet/scrollableWrapper/ScrollableWrapper';
import { ErrorMessage } from '../../errorMessage/ErrorMessage';
import { TableTopInfo, TableTopTab } from '../type';

import { CashedMultipliersAndWinBottomBar } from './singleCashedMultipliersAndWins/CashedMultipliersAndWinBottomBar';
import { CashedMultipliersAndWinTopBar } from './singleCashedMultipliersAndWins/CashedMultipliersAndWinTopBar';

import styles from './CashedMultipliersAndWins.module.css';

export const TableTopWins: FC = () => {
  const id = useId();
  const dispatch = useGameDispatch();
  const tableTopDataFetcher = useTableTopDataFetcher();
  const isApiRejected = useHighflyerGameStateSlice.getIsApiRejected();
  const tableTopData = useHighflyerGameStateSlice.tableTopData().wins;
  const currentPeriod = useHighflyerGameStateSlice.currentCalenderOption();
  const isTimerStarted = useGameStateSlice.getCurrentStatus() === GameStatus.PlaceYourBets;

  useEffect(() => {
    dispatch(highflyerGameStateActions.setErrorOccured());
    dispatch(highflyerGameStateActions.setCurrentTopTab(TableTopTab.WINS));
  }, [dispatch]);

  useEffect(() => {
    dispatch(highflyerGameStateActions.setErrorOccured());
    tableTopDataFetcher(TableTopTab.WINS, true);
  }, [currentPeriod, dispatch, tableTopDataFetcher]);

  useEffect(() => {
    if (!isApiRejected && isTimerStarted) {
      tableTopDataFetcher(TableTopTab.WINS, isTimerStarted);
    }
  }, [isApiRejected, isTimerStarted, tableTopDataFetcher]);

  return (
    <ScrollableWrapper>
      {((): ReactElement => {
        if (!tableTopData && isApiRejected) {
          return (
            <ErrorMessage
              title="HIGHFLYER_FAILED_TO_LOAD"
              message="HIGHFLYER_INTERNAL_ERROR"
              disabled={false}
              loading={false}
              onClick={(): void => {
                tableTopDataFetcher(TableTopTab.WINS, true);
                dispatch(highflyerGameStateActions.setErrorOccured());
              }}
            />
          );
        } else if (!tableTopData && !isApiRejected) {
          return <Loader />;
        } else {
          return (
            <div className={styles.tableTop_wins_container}>
              {tableTopData &&
                tableTopData.map((item: TableTopInfo, index: number) => {
                  return (
                    <div className={styles.singleItem} key={`table-top-win-${id}`}>
                      <CashedMultipliersAndWinTopBar
                        currentTab={'win'}
                        betAmount={item.betAmount}
                        winAmount={item.winAmount}
                        multiplier={item.cashOutMultiplier}
                      />
                      <CashedMultipliersAndWinBottomBar
                        currentTab={'win'}
                        nickname={item.nickname}
                        betTime={item.betTime}
                        crashMul={item.multiplier}
                        index={index}
                      />
                    </div>
                  );
                })}
            </div>
          );
        }
      })()}
    </ScrollableWrapper>
  );
};
